import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/bonuses';
import { bonusTotalValue, totalBonuses } from '../data/offer';
export function BonusSection() {
  return <section className="bg-mist py-16 sm:py-20" aria-labelledby="bonus-title" data-id="element-20" data-mp="22ebwf84sbiga">
      <div className="mx-auto max-w-5xl px-4" data-id="element-21" data-mp="1ydry418h68sk">
        <div className="text-center" data-id="element-22" data-mp="1ybx8waq67uio">
          <span className="inline-flex items-center gap-2 rounded-md bg-safety px-4 py-2 text-xs font-extrabold uppercase tracking-[.15em] text-navyDeep" data-id="element-23" data-mp="1anxmto3t0saf">
            <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-24" data-mp="15n9lo9lv2v2h" /> Bonos incluidos
          </span>
          <h2 id="bonus-title" className="mt-4 text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-25" data-mp="1ji2axzrjzpm9">Los {totalBonuses} bonos estratégicos</h2>
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-26" data-mp="qzycufh2dp62">
          {bonuses.map((bonus, index) => {
          const Icon = bonus.icon;
          return <motion.article key={bonus.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: index * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className={`flex flex-col rounded-xl border bg-white p-6 shadow-card ${bonus.wide ? 'border-2 border-safety md:col-span-2' : 'border-line'}`} data-id="element-27" data-mp="mymijwn8wfrj" data-mpi={index}>
                <div className="flex items-center gap-3" data-id="element-28" data-mp="1qv1t7hjvp31f">
                  <span className="flex h-10 w-10 items-center justify-center rounded-md bg-navy text-safety" data-id="element-29" data-mp="1vrijoiejvtho">
                    <Icon className="h-5 w-5" aria-hidden="true" data-id="element-30" data-mp="20qd94370wgar" />
                  </span>
                  <p className="text-[11px] font-extrabold uppercase tracking-[.16em] text-muted" data-id="element-31" data-mp="25qribokd1wad">Bono {bonus.number}</p>
                </div>
                <h3 className="mt-4 text-lg font-extrabold uppercase leading-tight text-ink" data-id="element-32" data-mp="3c8o5z0un46wy">{bonus.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-muted" data-id="element-33" data-mp="3h7hlszxega0a">{bonus.description}</p>

                {bonus.items && <ul className="mt-4 flex flex-wrap gap-2" data-id="element-34" data-mp="1c4as2v9t35dq">
                    {bonus.items.map(item => <li key={item} className="rounded-md border border-line bg-mist px-3 py-1 text-xs font-semibold text-muted" data-id="element-35" data-mp="1c6okewd3q3hl">
                        {item}
                      </li>)}
                  </ul>}

                {bonus.purpose && <p className="mt-4 flex-1 rounded-lg border-l-4 border-prevention bg-preventionSoft px-4 py-3 text-sm text-ink" data-id="element-36" data-mp="yce5t7utjpp9">
                    Ideal para <b className="font-extrabold" data-id="element-37" data-mp="tfduoij43wra">{bonus.purpose}</b>.
                  </p>}

                <p className="mt-auto flex flex-wrap items-center justify-between gap-3 border-t border-line pt-4 text-sm" data-id="element-38" data-mp="176sh6zc8ag33">
                  <span className="text-muted line-through" data-id="element-39" data-mp="12ceiamycxqto">Valor {bonus.value}</span>
                  <span className="rounded-md bg-prevention px-3 py-1 text-xs font-extrabold uppercase tracking-wide text-white" data-id="element-40" data-mp="en3q3tv2p4r5">Gratis</span>
                </p>
              </motion.article>;
        })}
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-4 rounded-xl bg-navy px-6 py-6 text-center sm:flex-row sm:text-left" data-id="element-41" data-mp="hbk8tut50em">
          <p className="text-xs font-extrabold uppercase tracking-[.18em] text-safety" data-id="element-42" data-mp="3mre477227xw5">Total de bonos</p>
          <p className="font-display text-2xl font-extrabold text-white sm:text-3xl" data-id="element-43" data-mp="3rqr0sjiqgjbx">{totalBonuses} bonos exclusivos</p>
        </div>

        <p className="mx-auto mt-6 max-w-xl rounded-lg border border-safety bg-safetySoft px-5 py-4 text-center text-sm font-semibold text-ink" data-id="element-44" data-mp="janou1kl88hs">
          Valor total de los {totalBonuses} bonos <span className="mx-1 text-muted line-through" data-id="element-45" data-mp="9b6lvrwq08pi">{bonusTotalValue}</span>
          <b className="font-extrabold" data-id="element-46" data-mp="e9rr65qtxikt">→ GRATIS con tu Megapack</b>
        </p>
      </div>
    </section>;
}